// import gsap from 'gsap'
import { bp, callAfterResize, l, mm, preventOrphan, sel, selAll, stResizeObserver, wrapLastTwo } from './utils'
// import { SplitText } from 'gsap/SplitText'
// import SplitType from 'split-type'
// import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { VidstackPlayer, VidstackPlayerLayout } from 'vidstack/global/player'

gsap.registerPlugin(ScrollTrigger)
// gsap.registerPlugin(SplitText, ScrollTrigger)

export default function Home() {
  // console.log('Home0912.js loaded')
  // return
  const isDeskSafari = !!(window.safari && window.safari.pushNotification)
  const ifChromeBlur = !isDeskSafari ? { filter: 'blur(50px)' } : {}

  function testInit() {
    const sec$ = sel('.epic-test-sec')
    const modW$ = document.body.appendChild(sec$.querySelector('.mod-w'))
  }
  window.addEventListener('load', function () {
    document.fonts.load('1rem "DM Sans"').then(() => {
      const tW$ = sel('.h1--epic-w')
      // tW$.classList.add('blur-wrap')

      // return
      const navbarW$ = sel('.navbar-a')
      const navbar$ = sel('#navbar')

      // Plans
      const planList$ = sel('.membership__plan-list')
      const planItem$a = planList$.selAll('.membership__plan')
      const planTl = gsap.timeline({ defaults: { ease: 'power1.out', duration: 1 } }).from(planItem$a, { autoAlpha: 0, y: 20, stagger: 0.1 }, 0)
      ScrollTrigger.create({
        trigger: planList$,
        start: 'top 90%',
        animation: planTl,
        toggleActions: 'play none none reverse',
      })

      // Prop cards
      const propList$ = sel('.apex__list')
      const propItem$a = propList$.selAll('.card-service')

      const div = document.createElement('div')
      div.classList.add('props__mod-w')

      propItem$a.forEach((card, i) => {
        const modW$ = card.sel('.mod-w')
        if (!modW$) return
        const mod$ = card.sel('.mod')
        const modBg$ = card.sel('.mod-bg')
        const modX$ = card.sel('.mod__x-w')
        div.appendChild(modW$)
        const tl = gsap
          .timeline({ defaults: { duration: 1, ease: 'power4.inOut' }, paused: true })
          //
          .to(modW$, { autoAlpha: 1 })
          .fromTo(mod$, { x: 50 }, { x: 0 }, 0)
        gsap.set(modW$, { display: 'block', autoAlpha: 0, x: 0 })
        card.addEventListener('click', (e) => {
          // e.stopImmediatePropagation()
          tl.play()
          console.log(mod$)
        })
        ;[modBg$, modX$].forEach((el$) => {
          // e.stopImmediatePropagation()
          el$.addEventListener('click', (e) => {
            tl.reverse()
          })
        })
        // console.log('item$', item$)
      })
      document.body.appendChild(div)

      const propTl = gsap.timeline({ defaults: { ease: 'power4.out', duration: 1 } }).from(propItem$a, { autoAlpha: 0, y: 5, stagger: 0.1 }, 0)
      ScrollTrigger.create({
        trigger: propList$,
        start: 'top 90%',
        animation: propTl,
        toggleActions: 'play none none reverse',
      })

      // Test
      console.log('x')
      const epic$ = sel('.extend-sec')
      const testW$ = sel('.epic-test-sec-w')
      const test$ = sel('.epic-test-sec')
      const testC$ = sel('.epic-test__c')
      const testA$ = test$.querySelector('.btn')
      const tableW$ = sel('.epic-table-sec-w')
      const table$ = sel('.epic-table-sec')
      // gsap.set(epic$, { marginBottom: '-100vh' })
      gsap.set(test$, { yPercent: -100 })
      // gsap.set(test$, { marginTop: '-100vh' })
      // gsap.set(test$, { marginTop: '-100vh', marginBottom: '-100vh' })

      const testTl = gsap.timeline({ defaults: { ease: 'none', duration: 1 } })
      ScrollTrigger.create({
        trigger: epic$,
        start: 'bottom bottom',
        end: '+=100%',
        // end: '+=200%',
        scrub: true,
        pin: test$,
        pinSpacing: false,
        // animation: testTl,
      })
      async function videoModal() {
        const test$ = sel('.epic-test-sec')
        const videoBtn$a = test$.selAll('.btn')
        if (!videoBtn$a || videoBtn$a.length === 0) return

        const sec$ = sel('.epic-test-sec')
        const modW$ = document.body.appendChild(sec$.querySelector('.mod-w'))
        // const modW$ = sec$.querySelector('.mod-w')

        const close$ = modW$.querySelector('.mod__x-w')
        const mod$ = modW$.querySelector('.mod')
        const bg$ = modW$.querySelector('.mod-bg')

        const player$ = modW$.sel('.custom_player.is--test') || modW$.sel('.custom_player-9x16')
        // console.log(_player.getAttribute('src'))
        // const src = _player.getAttribute('data-src') || _player.getAttribute('src')
        const player = await VidstackPlayer.create({
          target: player$,
          // src: src,
          // src: 'vimeo/1061484821',
          // poster:
          // 'https://cdn.prod.website-files.com/655b9a852f3d2a5de3c90048/6826898440714274aa9fd120_67575b133690ca3c5bb9254a_test_img1_q85-gigapixel-low%20resolution%20v2-4x%20copy.webp',
          crossOrigin: true,
          playsInline: true,
          viewType: 'video',
          load: 'idle',
          layout: new VidstackPlayerLayout(),
          // Ensure video actually reaches an end state (Vimeo can loop by default on some embeds)
          loop: false,
        })

        let endedHandled = false
        let rewindAfterClose = false

        // Hide/show controls helpers, when modal is closing
        const hideControls = () => {
          player$.classList.add('is--hide-controls')
        }
        const showControls = () => {
          player$.classList.remove('is--hide-controls')
        }

        const handleEnded = () => {
          if (endedHandled) return
          endedHandled = true
          // Mark that we should rewind once the modal close animation finishes
          rewindAfterClose = true
          closeModal()
        }

        // Primary
        player.addEventListener('ended', handleEnded)

        const onTimeUpdate = () => {
          const { currentTime, duration, paused } = player.state
          // Guard: only trigger near-end fallback while playing
          if (duration && !paused && currentTime >= duration - 0.25) handleEnded()
        }
        player.addEventListener('time-update', onTimeUpdate)
        gsap.set(modW$, { display: 'flex', autoAlpha: 0 })
        modW$.classList.add('display-hide')
        const tl = gsap
          .timeline({ defaults: { duration: 1, ease: 'power4.inOut' }, paused: true })
          .to(modW$, { autoAlpha: 1 })
          .from(mod$, { y: 50 }, 0)

        // When the modal finishes closing, rewind only if it closed because the video ended
        tl.eventCallback('onReverseComplete', () => {
          modW$.classList.add('display-hide')
          if (!rewindAfterClose) return
          try {
            player.currentTime = 0
          } catch (err) {
            // Some providers may delay seeking until ready
          } finally {
            rewindAfterClose = false
          }
        })
        tl.eventCallback('onStart', () => {
          modW$.classList.remove('display-hide')
          showControls()
        })

        const closeModal = (e) => {
          e?.stopImmediatePropagation()
          // console.log('closeModal')
          hideControls()

          tl.reverse()
          // Pause and reset to start so next open doesn't immediately re-trigger near-end logic
          player.pause()
        }
        ;[...videoBtn$a].forEach((btn) => {
          btn.onclick = (e) => {
            endedHandled = false
            setTimeout(() => {
              // reliably disable autoplay mute
              // player.muted = false
              // player.volume = 1
            }, 1000)
            player.play()
            tl.play()

            // if (player.state.canPlay) {
            //   player.play()
            // } else {
            //   player.addEventListener(
            //     'can-play',
            //     (event) => {
            //       player.play()
            //     },
            //     { once: true }
            //   )
            // }
          }
        })
        close$.onclick = closeModal
        bg$.onclick = closeModal
        mm.add(bp.tabUp, () => {})

        // callAfterResize(() => closeModal())
      }
      videoModal()
      mm.add(bp.tabUp, () => {
        // Footer

        const cta$ = sel('.epic-cta-sec')
        const ctaH$ = cta$.querySelector('h2')
        const ctaHsT$ = SplitText.create(ctaH$, { type: 'words, chars' })
        const ctaP$ = cta$.querySelector('.epic-cta__info>div:not(.button-group)')
        const ctaBtn$ = cta$.querySelector('.btn')
        const ctaBgSvg$ = cta$.querySelector('.epic-cta__bg-w.is--svg')
        const ctaBgWebp$ = cta$.querySelector('.epic-cta__bg-w-w.is--webp')
        const footer$ = sel('.footer')
        console.log(ctaBgSvg$, ctaBgWebp$)
        if (isDeskSafari) {
          ctaBgSvg$.style.display = 'none'
          ctaBgWebp$.style.display = 'block'
        }
        const ctaTl = gsap
          .timeline({ defaults: { ease: 'power3.out', duration: 1 } })
          //
          .from(
            ctaHsT$.chars,
            {
              autoAlpha: 0,
              // filter: 'blur(50px)',
              ...ifChromeBlur,
              stagger: 0.03,
              ease: 'none',
            },
            0
          )
          .from(ctaP$, { autoAlpha: 0, y: -20 }, '<50%')
          .from(ctaBtn$, { autoAlpha: 0, y: -20 }, '<10%')
          .from(footer$, { y: 20, autoAlpha: 0, duration: 3 }, '<10%')

        ScrollTrigger.create({
          trigger: cta$,
          start: 'top 80%',
          // end: '+=100%',
          // scrub: true,
          animation: ctaTl,
          toggleActions: 'play none none reverse',
        })
      })
    })
    stResizeObserver()
  })
}
